<template>
  <div>
    <SystemLogs></SystemLogs>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

const SystemLogs = defineAsyncComponent(() =>
  import("@/components/systemLogs/SystemLogs")
);

export default {
  name: "SystemLogsView",
  components: {
    SystemLogs,
  },
};
</script>
